export default __webpack_public_path__ + "static/media/play-black.e6b10951.svg";